import { Translation, ViewModelLineType } from "src/app/state-management/calculation-state";
import { Margin, RowStyle } from "./types/pdf-export.types";
import { Branding, CellFormat } from "./types/pdf-cell.types";
import { FontWeight } from "./pdf-export-service.settings";

export const formatterPercentage = new Intl.NumberFormat('nl-NL', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 5,
});

export const BULLET_WIDTH = 10;
export const FOOTER_HEIGHT = 70;

export const PDF_LINE_SPACING_FACTOR = 1.35;

export const A4_LENGTH_POINTS = 841.89;
export const A4_WIDTH_POINTS = 595.28;

export const PageNumberText1: Translation = {
    nl: 'pagina', en: 'page'
}

export const PageNumberText2: Translation = {
    nl: 'van', en: 'of'
}

export const DEFAULT_CELL_MARGINS: Margin = { left: 2, top: 2, right: 2, bottom: 2 };

export const DEFAULT_ROW_STYLE: RowStyle = {
    textStyle: {
        fontSize: 10,
        color: 0x000000
    }
}

export const FOOTER_MAP = new Map<Branding, Translation>([
    [Branding.TO_BUILD, {
        nl: 'Winde 3 | 5667 AX Geldrop | T +31(0)40 290 74 83 | info@tobuild.nl | www.tobuild.nl | KvK Eindhoven 54239419 | BTW NL851224301B01 | IBAN NL41RABO0153734132 | BIC RABONL2U',
        en: 'Winde 3 | 5667 AX Geldrop | T +31(0)40 290 74 83 | info@tobuild.nl | www.tobuild.nl | KvK Eindhoven 54239419 | BTW NL851224301B01 | IBAN NL41RABO0153734132 | BIC RABONL2U'
    },],
    [Branding.TO_BUILD_PROJECTS, {
        nl: 'Winde 3 | 5667 AX Geldrop | T +31(0)40 290 74 83 | info@tobuild.nl | www.tobuildprojects.nl | CoC Eindhoven 77774264 | VAT NL861138740B01 | IBAN NL04RABO0350585628 | BIC RABONL2U',
        en: 'Winde 3 | 5667 AX Geldrop | T +31(0)40 290 74 83 | info@tobuild.nl | www.tobuildprojects.nl | CoC Eindhoven 77774264 | VAT NL861138740B01 | IBAN NL04RABO0350585628 | BIC RABONL2U'
    }],
    [Branding.PGA, {}],
])

export const TRANSLATIONS: { [key: string]: Translation } = {
    'page': { nl: 'pagina', en: 'page' },
    'van': { nl: 'van', en: 'of' },
    'disclaimer_to_build': { nl: 'Alle leveringen en/of werkzaamheden geschieden volgens de Algemene voorwaarden van To Build B.V. Deze worden op verzoek verstrekt. Tevens is op al onze documenten onze privacy policy van toepassing zoals deze is gepubliceerd op onze website', en: 'Alle leveringen en/of werkzaamheden geschieden volgens de Algemene voorwaarden van To Build B.V. Deze worden op verzoek verstrekt. Tevens is op al onze documenten onze privacy policy van toepassing zoals deze is gepubliceerd op onze website' }
}

// Try to keep row together based on the line type. Positive numbers indicate number of lines to keep together with the next lines, 
// negative numbers indicate number of lines to keep together with the previous lines. 
export const breakStrategy: { [key in ViewModelLineType]?: number } = {
    [ViewModelLineType.CATEGORY]: 2,
    [ViewModelLineType.SUBCATEGORY]: 1,
    [ViewModelLineType.SUBTOTAL]: -3,
    [ViewModelLineType.TOTAL]: -3,
    [ViewModelLineType.TEXT]: -1,
    [ViewModelLineType.TAIL_SUBTOTAL]: -2,
}

// Some extra whitespace for line types
export const additionalWhitespace: { [key in ViewModelLineType]?: number } = {
    [ViewModelLineType.CATEGORY]: 4,
    [ViewModelLineType.SUBCATEGORY]: 2,
    [ViewModelLineType.SUBTOTAL]: 2,
    [ViewModelLineType.TOTAL]: 4,
    [ViewModelLineType.TEXT]: 0,
    [ViewModelLineType.CALCULATION]: 1,
}

export const DEFAULT_HEADER_STYLE: CellFormat = {
    textStyle: {
        fontSize: 8,
        weight: FontWeight.THIN,
        color: 0x000000
    },
    horizontalTextAlignment: 'right',
    margin: {
        top: 4,
        bottom: 1,
        right: 2,
        left: 2
    }
}